// extracted by mini-css-extract-plugin
export default {"container":"iB-z","vocBtn":"jB-z","disabled":"kB-z"};